import isValidNumber from "../typeguards/isValidNumber.js";
import getScaleBandwidth from "./getScaleBandwidth.js";
/** Returns a function that takes a Datum as input and returns a scaled value, correcting for the scale's bandwidth if applicable. */
export default function getScaledValueFactory(scale, accessor) {
  let align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'center';
  return d => {
    const scaledValue = scale(accessor(d));
    if (isValidNumber(scaledValue)) {
      const bandwidthOffset = (align === 'start' ? 0 : getScaleBandwidth(scale)) / (align === 'center' ? 2 : 1);
      return scaledValue + bandwidthOffset;
    }
    return NaN;
  };
}